module.exports = __webpack_public_path__ + "img/9788963010922.6bb57e70.jpg";